<template>
  <AppBar />
  <v-main>
    <v-container style="max-width: 850px" class="py-6">
      <h1 class="page-title"># All Projects</h1>

      <div
        v-for="p in myprojects"
        :key="p.title"
        class="research-card"
      >
        <v-row class="research-item" align="center">
          <v-col cols="12" sm="3" class="text-center">
            <img :src="p.img" class="research-media research-img" :alt="p.title" />
          </v-col>
          <v-col cols="12" sm="9">
            <a :href="p.link" target="_blank">
              <span class="paper-title">{{ p.title }}</span>
            </a>
            <br />
            <span class="venue-badge">{{ p.course }}</span>
            <span class="venue-badge" style="margin-left: 6px">{{ p.time }}</span>
            <p class="paper-desc">{{ p.text }}</p>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import AppBar from "../components/AppBar.vue";
import { myprojects } from "../data.js";

export default {
  components: {
    AppBar,
  },
  data() {
    return {
      myprojects,
    };
  },
};
</script>

<style scoped>
.page-title {
  font-size: 28px;
  font-weight: 700;
  color: lightskyblue;
  text-align: center;
  margin-bottom: 30px;
}

/* ── Links ── */
a {
  color: #64b5f6;
  text-decoration: none;
  transition: color 0.2s ease;
}
a:hover {
  color: #f09228;
}

/* ── Research Cards ── */
.research-card {
  padding: 16px 12px;
  margin-bottom: 8px;
  border-radius: 12px;
  border: 1px solid transparent;
  transition: background 0.25s ease, border-color 0.25s ease, transform 0.2s ease;
}
.research-card:hover {
  background: rgba(135, 206, 250, 0.04);
  border-color: rgba(135, 206, 250, 0.15);
  transform: translateY(-2px);
}

.research-item {
  margin-bottom: 0;
}

.research-media {
  width: 100%;
  max-width: 180px;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.research-img {
  object-fit: contain;
}

.paper-title {
  font-weight: 700;
  font-size: 15px;
  line-height: 1.5;
}

.venue-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  color: lightskyblue;
  background: rgba(135, 206, 250, 0.12);
  padding: 2px 10px;
  border-radius: 12px;
  margin-top: 4px;
}

.paper-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #999;
  line-height: 1.6;
}

/* ── Mobile ── */
@media (max-width: 600px) {
  .page-title {
    font-size: 24px;
  }

  .research-media {
    max-width: 140px;
  }
}
</style>